import styles from './dashboardConfigModal.module.css'
import { useEffect, useState } from 'react'
import { Modal, ModalId, useUIState } from '../../../../features/ui'
import { DashboardWidgetPreference } from '../../../system'
import { DashboardWidgetDefinition } from '../../types'

type Props<T> = {
    widgets: DashboardWidgetDefinition<T>[]
    preferences: DashboardWidgetPreference[]
    onApply: (preferences: DashboardWidgetPreference[]) => void
}

// Which cards the home shows (where they go and their size is set on the grid itself)
export const DashboardConfigModal = <T,>(props: Props<T>) => {
    const { widgets, preferences, onApply } = props

    const [visibleIds, setVisibleIds] = useState<string[]>([])
    const { openedModal } = useUIState()

    // Every time it's opened it starts from the current configuration
    useEffect(() => {
        if (openedModal === ModalId.DASHBOARD_CONFIG) {
            setVisibleIds(preferences.filter(preference => preference.visible).map(preference => preference.id))
        }
    }, [openedModal])

    const toggle = (id: string, visible: boolean) =>
        setVisibleIds(current => visible ? [...current, id] : current.filter(visibleId => visibleId !== id))

    // A card that is shown again goes to the end of the grid
    const onSubmit = () => onApply(preferences.map(preference => {
        const visible = visibleIds.includes(preference.id)
        return visible && !preference.visible ?
            { id: preference.id, size: preference.size, visible } :
            { ...preference, visible }
    }))

    return (
        <Modal
            modalId={ModalId.DASHBOARD_CONFIG}
            title="Tarjetas del inicio"
            widthSize="m"
            submitLabel="Aplicar"
            onSubmit={onSubmit}
        >
            <p className={styles.hint}>
                Elegí qué tarjetas ver. {visibleIds.length} de {widgets.length} visibles.
            </p>
            <ul className={styles.list}>
                {widgets.map(widget => (
                    <li key={widget.id} className={styles.item}>
                        <input
                            id={`dashboard-widget-${widget.id}`}
                            type="checkbox"
                            className="form-check-input mt-0"
                            checked={visibleIds.includes(widget.id)}
                            onChange={e => toggle(widget.id, e.target.checked)}
                        />
                        <label htmlFor={`dashboard-widget-${widget.id}`} className={styles.texts}>
                            <span className={styles.title}>{widget.title}</span>
                            <span className={styles.description}>{widget.description}</span>
                        </label>
                    </li>
                ))}
            </ul>
        </Modal>
    )
}
